import React, { useState, useEffect } from "react";
import { useLocation, Link, useNavigate } from "react-router-dom";
import "./Liga.css";
import { FaBars, FaTimes } from "react-icons/fa";

function Liga() {
  const location = useLocation();
  const [leagueData, setLeagueData] = useState(
    location.state || JSON.parse(localStorage.getItem("leagueData"))
  );

  const [menuOpen, setMenuOpen] = useState(false);
  const [equipos, setEquipos] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(2);
  const [touchStartX, setTouchStartX] = useState(0);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const navigate = useNavigate();

  const handlePlayersClick = () => {
    navigate("/jugadores", {
      state: leagueData,
    });
  };

  useEffect(() => {
    if (leagueData) {
      localStorage.setItem("leagueData", JSON.stringify(leagueData));

      const fetchEquipos = async () => {
        try {
          const response = await fetch(
            `http://localhost:3000/equipo-competicion/${leagueData.competitionId}`
          );
          const data = await response.json();
          setEquipos(data);
        } catch (error) {
          console.error("Error al obtener equipos:", error);
        }
      };

      if (leagueData.competitionId) {
        fetchEquipos();
      }
    }
  }, [leagueData]);

  if (!leagueData) {
    return <div>Cargando...</div>;
  }

  return (
    <div className="liga-container">
      <nav className="navbar">
        <div className="navbar-logo">
          <img src="./logonobg.png" alt="Logo" />
        </div>
        <div className={`navbar-links ${menuOpen ? "active" : ""}`}>
          <ul>
            <li>
              <Link to="/liga">Inicio</Link>
            </li>
            <li>
              <Link to="/mercado">Mercado</Link>
            </li>
            <li>
              <Link to="/fecha">Fecha</Link>
            </li>
            <li>
              <Link to="/jugadores" onClick={handlePlayersClick}>
                Jugadores
              </Link>
            </li>
            <li>
              <Link to="/opciones">Opciones</Link>
            </li>
            <li>
              <Link to="/perfil">Perfil</Link>
            </li>
          </ul>
        </div>
        <div className="navbar-toggle" onClick={toggleMenu}>
          {menuOpen ? <FaTimes /> : <FaBars />}
        </div>
      </nav>

      <div className="content">
        <h1>{leagueData.nameleague}</h1>
        {leagueData.leagueId ? (
          <>
            <h3>Competición: {leagueData.namecompetition}</h3>

            {/* Desktop */}
            {/* Desktop - Scroll horizontal */}
            <div className="escudos-horizontal desktop">
              {equipos.map((equipo, index) =>
                equipo.ec_activo ? (
                  <img
                    key={index}
                    src={equipo.equipo_escudo}
                    alt={equipo.equipo_nombre}
                    title={equipo.equipo_nombre}
                    className="escudo-img"
                    onClick={() =>
                      navigate("/detalle-equipo", { state: equipo })
                    }
                    style={{ cursor: "pointer" }}
                  />
                ) : (
                  <img
                    key={index}
                    src={equipo.equipo_escudo}
                    alt={equipo.equipo_nombre}
                    title={equipo.equipo_nombre}
                    className="escudo-img inactivo"
                    style={{ pointerEvents: "none" }}
                  />
                )
              )}
            </div>

            {/* Mobile - Swipe carrusel */}
            <div
              className="escudos-carrusel mobile"
              onTouchStart={(e) => setTouchStartX(e.touches[0].clientX)}
              onTouchEnd={(e) => {
                const touchEndX = e.changedTouches[0].clientX;
                const diff = touchStartX - touchEndX;
                if (diff > 50 && currentIndex < equipos.length - 1) {
                  setCurrentIndex(currentIndex + 1);
                } else if (diff < -50 && currentIndex > 0) {
                  setCurrentIndex(currentIndex - 1);
                }
              }}
            >
              <div
                className="carrusel-track"
                style={{
                  transform: `translateX(calc(50% - ${
                    (currentIndex + 0.5) * 80
                  }px))`,
                }}
              >
                {equipos.map((equipo, index) => (
                  <div
                    key={index}
                    className={`carrusel-item ${
                      index === currentIndex ? "active" : ""
                    }`}
                    onClick={() => {
                      if (equipo.ec_activo && index === currentIndex) {
                        navigate("/detalle-equipo", { state: equipo });
                      } else {
                        setCurrentIndex(index);
                      }
                    }}
                    title={equipo.equipo_nombre}
                    style={{
                      pointerEvents: equipo.ec_activo ? "auto" : "none",
                      filter: equipo.ec_activo ? "none" : "grayscale(100%)",
                    }}
                  >
                    <img
                      src={equipo.equipo_escudo}
                      alt={equipo.equipo_nombre}
                    />
                  </div>
                ))}
              </div>
            </div>
          </>
        ) : (
          <p>No se proporcionó ID de la liga ni la competición.</p>
        )}
      </div>

      <footer className="footer">
        <div className="social-links">
          <a
            href="https://x.com/ColFantasy"
            target="_blank"
            rel="noopener noreferrer"
          >
            Twitter
          </a>
          <a
            href="https://www.instagram.com/colfantasy/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Instagram
          </a>
          <a
            href="mailto:info.colfantasy@gmail.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            Gmail
          </a>
        </div>
        <p>&copy; 2025 ColFantasy. Todos los derechos reservados.</p>
      </footer>
    </div>
  );
}

export default Liga;
